import { ErrorHandler, Injectable, inject } from '@angular/core';
import { ConsoleErrorService } from '../components/console-error-panel/console-error.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private consoleErrorService = inject(ConsoleErrorService);
  handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    if (chunkFailedMessage.test(error?.message)) {
      window.location.reload();
      return;
    }

    /*
    if (localStorage.getItem('showConsoleErrorPannel') === 'true') {
      let message = error?.message || error?.toString() || 'Unknown error';
      let stack = error?.stack || '';
      if (stack) {
        this.consoleErrorService.addError(message, stack);
      }
    }
      */
    console.error(error);
  }
}
